// Home screen copy shared by both layouts. Source: the production front end (assets/js/app.js vLandingMobile,
// assets/desktop-ui/brand-home.js, the GEO block of index.html).

/** Collapsed FAQ entry at the end of the desktop page (index.html section.geo-faq). */
export const FAQ_ENTRY_ITEMS: { q: string; a: string }[] = [
  { q: '哪里可以使用导游资格考试在线题库？', a: '「导游学霸」（daoyouxueba.com）提供科目一至科目四题库、章节练习和文字解析，并按学习进度组织错题复习；考点地图与知识图谱按页面关联内容展示。' },
  { q: '导游学霸是什么？', a: '导游学霸是面向全国导游资格考试的独立学习系统，围绕官方大纲提供四科题库、学习进度、考点地图和省级考试资料入口。各页面会标明内容来源与适用范围。' },
  { q: '导游学霸的题库都有哪些题？', a: '历年考题 + 高质量模拟题 + 原创改编题，紧扣考纲全覆盖。部分题目标注了考试年份，便于对照复习；考试范围与现场考试要求以主管部门发布的大纲和通知为准。' },
  { q: '导游资格考试考哪几科？', a: '全国导游资格考试含笔试四科：科目一政策与法律法规、科目二导游业务、科目三全国导游基础知识、科目四地方导游基础知识；以及科目五现场考试（导游服务能力），由各省级文化和旅游行政部门组织实施。' },
  { q: '导游考试怎么备考？', a: '建议先查看官方大纲确定范围，再按章节学习与刷题，并用间隔复习巩固错题。科目五需按报考省份的现场考试大纲准备景点讲解。' },
]
